jQuery( 'body' ).ready( function ( $ ) {

  if ( $( '.slick-slider-customers' ).length > 0 ) {
    $( '.slick-slider-customers' ).slick( {
      dots: false,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 4000,
      slidesToShow: 2,
      prevArrow: $( '.testimony-icon-prev' ),
      nextArrow: $( '.testimony-icon-next' ),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: false,
            nextArrow: false,
          },
        },
      ],
    } );
  }

  $( '#story-service' ).on( 'change', function () {
    searchPostAjax();
  } );

  $( '#story-technology' ).on( 'change', function () {
    searchPostAjax();
  } );

  $( '#story-industry' ).on( 'change', function () {
    searchPostAjax();
  } );

  $( 'body' ).on( 'click', '.page-number', ( e ) => {
    var pageID = e.currentTarget.id;
    var paged  = $( '#' + pageID ).attr( 'data-page' );

    searchPostAjax( paged );
  } );

  $( 'body' ).on( 'click', '#page-previous', () => {
    var paged = $( '#page-previous' ).attr( 'data-previous' );

    searchPostAjax( paged );
  } );

  $( 'body' ).on( 'click', '#page-next', () => {
    var paged = $( '#page-next' ).attr( 'data-next' );

    searchPostAjax( paged );
  } );

  /**
   * This function performs an ajax query to render the html result on the page.
   *
   * @param pageCurrent current search page.
   */
  function searchPostAjax( pageCurrent = 1 ) {
    var $service    = $( '#story-service' ).find( 'option:selected' ).attr( 'value' );
    var $technology = $( '#story-technology' ).find( 'option:selected' ).attr( 'value' );
    var $industry   = $( '#story-industry' ).find( 'option:selected' ).attr( 'value' );

    var $data = {
      action: 'more_post_stories',
      paged: pageCurrent,
      service: $service,
      technology: $technology,
      industry: $industry,
    };
    $.ajax( {
      type: 'POST',
      url: ajax_object.ajax_url,
      data: $data,
      beforeSend: function() {
        $( '.loading-results' ).addClass( 'active' );
        $( '.cards-result-stories' ).addClass( 'not-show' );
        $( '.results-not-found' ).addClass( 'not-show' );
      },
    } )
      .complete( function ( response ) {
        $( '.loading-results' ).removeClass( 'active' );
        $( '.cards-result-stories' ).removeClass( 'not-show' );
        $( '.results-not-found' ).removeClass( 'not-show' );
        $( '.stories-result' ).html( response ); // CHANGE THIS!
      } );
  }
} );
